<template>
  <div class="mod">
    <label
      class="remove-margin color-6f7 font-14"
      :class="{ require: required }"
    >
      {{ title }}
    </label>
    <multiselect
      v-if="!async"
      v-model="valueData"
      :label="label"
      :placeholder="placeholder"
      :tag-placeholder="tagPlaceholder"
      :track-by="trackBy"
      :options="optionsData"
      :multiple="multiple"
      :taggable="taggable"
      :show-labels="showLabel"
      :maxHeight="200"
      :searchable="searchable"
      @tag="addTag"
      @input="updateValue"
    >
      <div v-if="!taggable">
        <template slot="noResult"> Data tidak ditemukan </template>
        <template slot="tag" slot-scope="{ option, remove }" v-if="multiple">
          <div class="so-input-select-multiple-tag">
            <div class="d-flex-between-center">
              <div class="d-block pr-2">
                <div class="f-regular f-14 f-c-black">{{ option.title }}</div>
                <div class="f-reguler f-12 f-c-midgrey">
                  {{ option.subtitle }}
                </div>
              </div>
              <img
                src="@/assets/icons-menubar/close-x.svg"
                height="20px"
                alt=""
                @click="remove(option)"
              />
            </div>
          </div>
        </template>
        <template slot="singleLabel" slot-scope="props">
          <div class="f-regular f-14 f-c-black">{{ props.option.title }}</div>
          <div class="f-reguler f-12 f-c-midgrey">
            {{ props.option.subtitle }}
          </div>
        </template>
        <template slot="option" slot-scope="props">
          <div class="f-regular f-14 f-c-black">{{ props.option.title }}</div>
          <div class="f-reguler f-12 f-c-midgrey">
            {{ props.option.subtitle }}
          </div>
        </template>
      </div>
    </multiselect>

    <multiselect
      v-else
      v-model="valueData"
      :loading="isLoading || timer !== null"
      @search-change="getAsyncData"
      :label="label"
      :placeholder="placeholder"
      :tag-placeholder="tagPlaceholder"
      :track-by="trackBy"
      :options="optionsData"
      :maxHeight="200"
      :multiple="multiple"
      :taggable="taggable"
      :show-labels="showLabel"
      :searchable="searchable"
      @tag="addTag"
      @input="updateValue"
    >
      <div v-if="!taggable">
        <template slot="noOptions" slot-scope="props">
          Ketik untuk mencari...
        </template>
        <template slot="noResult"> Data tidak ditemukan </template>
        <template slot="tag" slot-scope="{ option, remove }" v-if="multiple">
          <div class="so-input-select-multiple-tag">
            <div class="d-flex-between-center">
              <div class="d-block pr-2">
                <div class="f-regular f-14 f-c-black">{{ option.title }}</div>
                <div class="f-reguler f-12 f-c-midgrey">
                  {{ option.subtitle }}
                </div>
              </div>
              <img
                src="@/assets/icons-menubar/close-x.svg"
                height="20px"
                alt=""
                @click="remove(option)"
              />
            </div>
          </div>
        </template>
        <template slot="singleLabel" slot-scope="props">
          <div class="f-regular f-14 f-c-black">{{ props.option.title }}</div>
          <div class="f-reguler f-12 f-c-midgrey">
            {{ props.option.subtitle }}
          </div>
        </template>
        <template slot="option" slot-scope="props">
          <div
            @click="
              () => {
                optionsData = [];
              }
            "
          >
            <div class="f-regular f-14 f-c-black">{{ props.option.title }}</div>
            <div class="f-reguler f-12 f-c-midgrey">
              {{ props.option.subtitle }}
            </div>
          </div>
        </template>
      </div>
    </multiselect>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";
import { regex } from "@/store/utils/vars";

export default {
  name: "SOInputSelectMultiple",
  components: {
    Multiselect,
  },
  props: {
    title: String,
    required: {
      type: Boolean,
      default: false,
    },
    label: String,
    placeholder: String,
    tagPlaceholder: {
      type: String,
      default: "+ Buat Kategori",
    },
    trackBy: String,
    options: Array,
    multiple: {
      type: Boolean,
      default: false,
    },
    taggable: {
      type: Boolean,
      default: false,
    },
    showLabel: {
      type: Boolean,
      default: false,
    },
    searchable: {
      type: Boolean,
      default: false,
    },

    // async mode
    async: {
      type: Boolean,
      default: false,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },

    value: Array,
  },
  data() {
    return {
      valueData: [],
      optionsData: [],
      timer: null,
      // value: [
      // 	{ name: 'Javascript', code: 'js' }
      // ],
      // options: [
      // 	{ name: 'Vue.js', code: 'vu' },
      // 	{ name: 'Javascript', code: 'js' },
      // 	{ name: 'Open Source', code: 'os' }
      // ]
    };
  },
  mounted() {
    this.valueData = this.value;
    this.optionsData = this.options;
    $(".multiselect__input").keyup(function () {
      $(".multiselect__input").each(function () {
        let strRegex = $(this).val().replace(regex.alphanumeric, "");
        $(this).val(strRegex);
      });
    });
  },
  watch: {
    value: {
      handler: function () {
        this.valueData = this.value;
      },
    },
    options: {
      handler: function () {
        this.optionsData = this.options;
      },
    },
  },
  methods: {
    addTag(newTag) {
      const tag = {
        id: newTag.substring(0, 1) + Math.floor(Math.random() * 1000000000),
        title: newTag,
        value: newTag.substring(0, 1) + Math.floor(Math.random() * 10000000),
      };
      this.options.push(tag);
      this.value.push(tag);
      if (!this.multiple && this.value.length > 1) {
        this.value[0] = tag;
      } else {
      }
      this.updateValue(this.valueData);
    },
    updateValue(arrSelected) {
      this.$emit("selected", arrSelected);
    },
    getAsyncData(query) {
      query = query.replace(regex.alphanumeric, "");
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
      this.timer = setTimeout(() => {
        if (query === "") {
          this.timer = null;
          return;
        }
        this.$emit("get-async-data", query);
        this.timer = null;
      }, 2000);
    },
  },
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
.so-input-select-multiple-tag {
  width: fit-content;
  background: #f6f6f6 !important;
  color: #000 !important;
  font-size: 14px;
  border: 1px solid #6f7287;
  border-radius: 4px;
  padding: 4px 8px;
  margin: 0 8px 8px 0;
}
</style>